import {
  FavoriteChangedActionType,
  FavoriteChangedErrorActionType,
  IFavoriteChangedAction,
  IFavoriteChangedErrorAction,
} from 'shared/actions/favorite';
import { IAppState, TActions } from 'shared/common/state';

export function favoriteReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case FavoriteChangedActionType:
      return getChangedState(state, action);
    case FavoriteChangedErrorActionType:
      return getChangedState(state, action);
  }

  return state;
}

function getChangedState(state: IAppState, action: IFavoriteChangedAction | IFavoriteChangedErrorAction): IAppState {
  return {
    ...state,
    results: {
      ...state.results,
      offers: state.results.offers.map(offer => {
        return offer.cianId === action.offerId || offer.id === action.offerId
          ? Object.assign({}, offer, {
              isFavorite: !offer.isFavorite,
            })
          : offer;
      }),
    },
  };
}
